import React from 'react';
import { FishingReport, WaterbodyDetail } from '@omniafishing/core';
import { getTechniqueByTechniqueName } from '../../../../redux/reference_data';
import { LINE_ATTRIBUTION } from '../../../../redux/cart';
import { ProductCard } from '../../../product_card/product_card';
import { ProductCarousel } from '../../../carousel/product_carousel';
import { useListAttributionUuid } from '../../../../hooks/use_list_attribution_uuid';
import { useSelector } from 'react-redux';
import styles from './waterbody_detail_top_products.less';
import { useQueryString } from '../../../../hooks/use_query_string';
import { OmniaQueryParams } from '../../../../lib/query_string';

interface RecentTrendingProductReportsCarouselProps {
  onKitClick: (fishingReport: FishingReport) => void;
  onTechniqueClick: () => void;
  hotbaitFishingReports: FishingReport[];
  waterbody: WaterbodyDetail;
}

export const RecentTrendingReportsCarousel = (props: RecentTrendingProductReportsCarouselProps) => {
  const { onKitClick, onTechniqueClick, hotbaitFishingReports, waterbody } = props;

  const { getCurrentQuery } = useQueryString();
  const currentQuery = getCurrentQuery<{
    [OmniaQueryParams.species]: string;
    [OmniaQueryParams.season_group]: string;
  }>();

  const speciesNameQueryParam = currentQuery[OmniaQueryParams.species];
  const seasonGroupQueryParam = currentQuery[OmniaQueryParams.season_group];

  const techniqueByTechniqueName = useSelector(getTechniqueByTechniqueName);
  const list_uuid = useListAttributionUuid();
  return (
    <div className={styles.carouselContainer}>
      <div className={styles.carouselHeadingWrapper}>
        <h3 className={styles.carouselHeading}>Recently Reported and Trending Baits</h3>
      </div>
      <div className={styles.carousel}>
        <ProductCarousel
          products={hotbaitFishingReports.map((report) => report.featured_product)}
          arrows
          list_id_title={`Recently Reported and Trending Baits`}
          list_uuid={list_uuid}
          additionalKeyProps={seasonGroupQueryParam + speciesNameQueryParam}
        >
          {hotbaitFishingReports.map((report, i) => (
            <div
              key={report.featured_product.shopify_product_handle + i}
              className={styles.topProduct}
            >
              <ProductCard
                product={report.featured_product}
                singleSourceFishingReport={report}
                ambassadorWithAvatar={report.user}
                position={i}
                fishingReportTechnique={techniqueByTechniqueName(report.technique.name)}
                onTechniqueClick={() => {
                  onTechniqueClick();
                }}
                lineItemAttribution={[
                  {
                    key: LINE_ATTRIBUTION.WATERBODY_ID,
                    value: waterbody.id,
                  },
                  {
                    key: LINE_ATTRIBUTION.FISHING_REPORT_ID,
                    value: report.id.toString(),
                  },
                ]}
                list_uuid={list_uuid}
                buildKit
                onKitClick={onKitClick}
              />
            </div>
          ))}
        </ProductCarousel>
      </div>
    </div>
  );
};
